import { render } from "./NewCyclist.vue?vue&type=template&id=2ea638a2"
import script from "./NewCyclist.vue?vue&type=script&lang=js"
export * from "./NewCyclist.vue?vue&type=script&lang=js"

import "./NewCyclist.vue?vue&type=style&index=0&id=2ea638a2&lang=css"

import exportComponent from "C:\\Mahoro\\projects\\crane\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__